import React from 'react';

import { constructQueryParamName } from '../../../util/search';

import PopupOpenerButton from '../PopupOpenerButton/PopupOpenerButton';

/**
 * CategoryFilterTabs renders top-level listing categories as individual
 * filter buttons. Clicking a tab applies that category immediately and
 * clicking the currently selected tab clears the category filter.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.config - The category filter config (key, scope, nestedParams)
 * @param {Array<Object>} props.listingCategories - Categories from categoryConfiguration
 * @param {Object} props.urlQueryParams - The current URL query params
 * @param {Function} props.onSelect - Handler that applies the changed query params
 * @returns {JSX.Element}
 */
const CategoryFilterTabs = props => {
  const { config, listingCategories = [], urlQueryParams, onSelect } = props;
  const { scope, nestedParams = [] } = config;
  const queryParamNames = nestedParams.map(p => constructQueryParamName(p, scope));
  const selectedCategory = urlQueryParams[queryParamNames[0]];

  const handleClick = categoryId => {
    const isSelected = selectedCategory === categoryId;
    // Set categoryLevel1 (or clear it when the selected tab is clicked again)
    // and clear deeper category levels, like SelectSingleFilter does on submit.
    const queryParams = queryParamNames.reduce(
      (acc, paramName, i) => ({
        ...acc,
        [paramName]: i === 0 && !isSelected ? categoryId : null,
      }),
      {}
    );
    onSelect(queryParams);
  };

  return (
    <>
      {listingCategories.map(category => (
        <PopupOpenerButton
          key={category.id}
          isSelected={selectedCategory === category.id}
          toggleOpen={() => handleClick(category.id)}
        >
          {category.name}
        </PopupOpenerButton>
      ))}
    </>
  );
};

export default CategoryFilterTabs;
